import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { CourseType, Duration, Modality } from '@/models/catalog/course';

export interface ProductCourse {
  id: number;
  name: string;
  about: string;
  course_type: CourseType;
  duration: Duration;
  modality: Modality;
  offers_quantity: number;
  skills: string[];
  course_program?: string | null;
}

export interface CourseDetails {
  course: ProductCourse;
  institution: {
    id: number;
    name: string;
    logo_url: string;
    logo_background_color: string;
    about: string;
  };
}

export const useCourseDetails = (id: number) => {
  const result = useQuery<{ data: CourseDetails }>({
    queryKey: [clientKeys.useCourseDetails, id],
    queryFn: async () => edupassClient.get(`/catalog/course/${id}`),
  });

  return { details: result?.data?.data, ...result };
};
